import React from 'react';
import { Typography, Box } from '@mui/material';

function About() {
  return (
    <Box my={6}>
      <Typography variant="h4" align="center" gutterBottom>
        About Wondersoft
      </Typography>
      <Typography align="center" color="text.secondary" maxWidth="md" mx="auto">
        At Wondersoft, we help businesses thrive in the digital world. From custom app development to intelligent automation — our solutions are designed to scale with your growth.
      </Typography>
    </Box>
  );
}

export default About;
